import React from 'react'
import { useEffect, useState } from 'react'
import Box from '@mui/system/Box'
import HeaderManageApplicant from '../components/HeaderManageApplicant'
import BodyManageApplicant from '../components/BodyManageApplicant'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import { Typography } from '@mui/material'
import { ChevronRight } from '@mui/icons-material'
import { useNavigate, useParams } from 'react-router-dom'
import useOpenClose from 'services/hooks/useOpenClose'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getOneJobAds, updateJobAds } from 'services/api/modules/recruitment/job-advertisment'

const ADNEXIO_JOBS_URL = process.env.REACT_APP_ADNEXIO_JOBS_URL

const ManageApplicant = () => {
  const navigate = useNavigate()

  // params is from the url
  const params = useParams()
  const id = params.id

  //api call
  const queryClient = useQueryClient()
  const {
    isLoading: getOneJobAdsIsLoading,
    error: getOneJobAdsError,
    data: getOneJobAdsData,
    refetch: jobAdsRefetch,
  } = useQuery(
    ['getOneJobAds', id],
    async () => {
      const { data } = await getOneJobAds(id)
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  return (
    <DashboardContainer
      headerTitle={
        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
          <Typography
            onClick={() => navigate('/app/recruitment/applicant-tracking')}
            sx={{ cursor: 'pointer', color: 'alternate.main' }}
          >
            Jobs
          </Typography>
          <ChevronRight sx={{ color: 'light-gray-text.main' }} />
          <Box>{getOneJobAdsData?.position_title}</Box>
        </Box>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <HeaderManageApplicant />
        <BodyManageApplicant />
      </Box>
    </DashboardContainer>
  )
}

export default ManageApplicant
